import { DollarSign } from "react-feather";
import { formatPrice } from "../../../utils/formatPrice"
import { DateRangeIcon } from "@mui/x-date-pickers";
import MoneyBagIcon from "../../../Components/Common/svg/reports/moneybagicon";

  export const tabs =[
    { id:1, label: "attachments" , name:"المرفقات" },
    { id:2, label: "storeInfo" , name:"معلومات المتجر" },
    {id:3,label:"branches" , name:"الفروع"},
    {id:4,label:"emplopyes",name:"الموظفين"},
    {id:5,label:"categories", name:"الفئات"},
    {id:6, label:"products", name:"المنتجات" },
    {id:7,label:"addons", name:"الإضافات"},
    {id:8,label:"orders", name:"الطلبات"},
    {id:9,label:"reviews", name:"التقييمات"},
    {id:10,label:"FinancialTransactions", name:"المعاملات المالية"},
    {id:11,label:"Documents", name:"الوثائق"}
  ]


   export const StatsStoreShowConfig =(store_setting ,created_at,commission_amount,currency_factor )=> [

    {
      title: "الحد الأدني للطلب",
      count: store_setting?.minimum_order_amount,
      color: "#003726",
      icon: <DollarSign/>,
      bgIcon: "#8AC6B4",
    },
 
    {
      title: "عمولة المتجر",
      count:  formatPrice( currency_factor ,commission_amount) ,
      color: "#FFCC00",
      icon: <MoneyBagIcon/>,       
      bgIcon: "#FFF7BA",
    },
    {
      title: "تاريخ الإنشاء",
      count: created_at,
      color: "#0F2B42",
      icon: <DateRangeIcon/>,
      bgIcon: "#E7EAEC",
    },
  ];